import styled from 'styled-components'

import UnlockedBase from '../../Unlocked'

const Unlocked = styled(UnlockedBase)`
  background: ${(props) => props.theme.colors.turnOrderCards.nemesis.normal};
`

export default Unlocked
